import ButtonContentBlock from 'models/common/content/block/ButtonContentBlock';

export default class ButtonContentBlockService {
	toModel(block) {
		return new ButtonContentBlock(block);
	}
}
